//
//

import { mapGetters, mapActions, mapMutations } from "vuex";
import { uid } from "quasar";
import { eventBus, publishAppPermissions, infoToastPublish } from "@/assets/js/appFunc";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQHistory from "@/components/Generics/AQHistory/AQHistory.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQRadio from "@/components/Generics/AQRadio/AQRadio.vue";
import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import AQList from "@/components/Generics/AQList/AQList.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQSkeleton from "@/components/Generics/AQSkeleton/AQSkeleton.vue";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import catalogDetails from "@/components/Catalogs/CatalogDetails/catalogDetails.vue";
import ImportExportModal from "../importExportModal/importExport.vue";
import EditCatModal from "../editCatModal/editCatModal.vue";

export default {
    name: "CatalogsList",
    components: {
        EditCatModal,
        ImportExportModal,
        AQInput,
        AQButton,
        AQRadio,
        AQDialog,
        AQMenu,
        AQEmptyState,
        AQList,
        catalogDetails,
        AQSkeleton,
        AQSearch,
        AQEmptySearch,
        AQHistory,
        AQModal
    },
    beforeRouteUpdate(to, from, next) {
        if (to.params.catalogId && this.newCatWasAdded) {
            this.$nextTick(() => {
                this.$store.commit("main/setInterfaceDirty", true);
            });
        } else if (!to.params.catalogId && from?.params.catalogId) {
            this.getCatList();
            this.$oneAtATime.destroyCurrentRoom();
            this.$store.commit("main/setSaveBtnVisible", true);
            this.$store.commit("rules/setShowRuleTesting", false);
            this.$root.$emit("showCheckedSaveBtn", false);
            this.$root.$emit("hideSaveBtn", true);
            this.$store.commit("catalogs/setSelectedCatalogData", []);
            this.$store.commit("catalogs/setSelectedCat", []);
            this.loadCatalogIndex = -1;
            this.catalogLoadedState = false;
            this.searchVal = "";
            this.isModified = false;
            this.newCatWasAdded = false;
        }
        next();
    },
    props: {
        readonly: Boolean
    },
    data() {
        return {
            isActive: true,
            paginationControl: { rowsPerPage: 10, page: 1 },
            searchVal: "",
            showDlg: false,
            showMenu: [],
            showModal: false,
            exportCatalog: false,
            optionExport: "xls",
            refreshCatalog: false,
            saveBeforeImportDlg: false,
            hideButtonsList: ["edit", "copy", "more"],
            hideBtnOnReadonly: ["edit", "copy", "delete", "more"],
            columnsCat: [
                {
                    name: "name",
                    label: "",
                    field: "name",
                    sortable: true,
                    align: "left"
                }
            ],
            isSelectedCat: null,
            showDialog: false,
            isModified: false,
            newSelectedCatalog: {},
            newSelectedIndex: null,
            catalogsReadonly: false,
            catalogLoadedState: false,
            loadCatalogIndex: -1,
            catalogsState: "",
            exportCatalogName: "",
            isSingleCatalog: false,
            deleteCatDialog: false,
            deleteCatalogId: "",
            skeletonState: true,
            newCatWasAdded: null,
            changeHistoryData: [],
            changeHistoryCurrentPage: 0,
            changeHistoryHasMoreItems: true,
            changeHistoryModal: false,
            currentSession: false,
            searchTrigger: false,
            activatedTriggered: false
        };
    },
    computed: {
        ...mapGetters("catalogs", [
            "noDataCatToShow",
            "items",
            "columns",
            "selectedCat",
            "selectedCatalogData",
            "unsavedChanges",
            "catalogsAlreadySaved",
            "getDeleteCatAction"
        ]),
        ...mapGetters("main", ["getCurrentApplicationId", "interfaceDirty"]),
        ...mapGetters("apps", ["currentApp", "processList", "getCurrentAppUserPermissions"]),
        canWriteCD() {
            return this.$route.params.permissions
                && this.$route.params.permissions.hasOwnProperty("permissionsData")
                && this.$route.params.permissions.permissionsData.hasOwnProperty("CD")
                && this.$route.params.permissions.permissionsData.CD === "w";
        },
        canWriteCS() {
            return this.$route.params.permissions
                && this.$route.params.permissions.hasOwnProperty("permissionsData")
                && this.$route.params.permissions.permissionsData.hasOwnProperty("CS")
                && this.$route.params.permissions.permissionsData.CS === "w";
        },
        isOwner() {
            return this.$route.params.permissions && this.$route.params.permissions.hasOwnProperty("owner");
        },
        readonlyCatalog() {
            return !(this.isOwner || this.canWriteCD);
        },
        canAddCatalog() {
            return this.isOwner || this.canWriteCS;
        },
        checkBtnDis() {
            return !(this.items || []).length;
        },
        filteredItems() {
            let itemsArr = [];
            const { query } = this.$route;
            if (this.searchVal || (query && Object.keys(query).length && query.search)) {
                itemsArr = this.items.filter(item => (item.name || "")
                    .toLowerCase()
                    .includes(this.searchVal.toLowerCase() || query.search));
            } else {
                itemsArr = this.items;
            }
            return itemsArr;
        },
        hasRightsBtns() {
            return this.isOwner || this.canWriteCD;
        },
        showInfoExport() {
            return (this.optionExport === "xls" && this.items.some(item => item.name.length > 31));
        },
        showSingleInfo() {
            return (this.optionExport === "xls" && this.exportCatalogName.length > 31);
        }
    },
    watch: {
        getCurrentApplicationId: {
            handler() {
                this.refreshCatalog = true;
                this.$store.commit("catalogs/setItems", []);
            },
            immediate: true
        },
        unsavedChanges: {
            handler(value) {
                if (((value && value.length) || value === "fromDelete") && this.$oneAtATime.state.$currentRoomEmpty) {
                    this.isModified = true;
                } else {
                    this.isModified = false;
                }
            },
            deep: true,
            immediate: true
        },
        selectedCat: {
            handler(value) {
                if (value && value.id) {
                    const catalogIndex = this.filteredItems.findIndex(elem => elem.id === value.id);
                    this.setNewSelectedCat(catalogIndex);
                    this.isSelectedCat = value.id;
                } else {
                    this.setNewSelectedCat(null, true);
                }
            },
            deep: true,
            immediate: true
        },
        selectedCatalogData: {
            handler() {
                this.$store.commit("catalogs/setDeleteCatAction", false);
            }
        },
        filteredItems: {
            handler(value) {
                this.catalogsState = value.length || (this.searchVal && !value.length) ? "catalogs" : "emptyCatalogs";
            }
        },
        showSearch: {
            handler(newVal) {
                this.searchTrigger = newVal;
                setTimeout(() => {
                    this.searchTrigger = false;
                }, 0);
            },
            immediate: true
        }
    },
    created() {
        this.$root.$on("bc__catalogs__open", this.breadcrumbsOpen);
    },
    activated() {
        this.isActive = true;
        this.activatedTriggered = true;
        this.loadCatalog();
        this.$root.$emit("showPublish", { noProcesses: !this.processList.length,
            showPublish: this.publishAppPermissions(this.currentApp, this.getCurrentAppUserPermissions) });
        this.$store.commit("main/setSaveBtnVisible", true);
        this.$store.commit("rules/setShowRuleTesting", false);
        this.$root.$emit("setReadonlyTag", this.readonlyCatalog);
        this.$root.$on("backendWebsocketEvents-refreshCatList", value => {
            if (value) {
                const { data } = value;
                const catId = data.split(":")[2];
                const actionType = data.split(":")[3];
                const newCatToastShown = (this.newCatWasAdded !== null) ? this.newCatWasAdded : false;
                if ((this.isSelectedCat !== catId) && ((!newCatToastShown && actionType === "persist") || (actionType === "delete")
                || (actionType === "recover"))) {
                    this.newCatWasAdded = null;
                    this.skeletonState = true;
                    this.getCatList().then(() => {
                        this.skeletonState = false;
                        if (!this.currentSession) {
                            this.$toast.showNotify({
                                type: "info",
                                message: this.$t("catalogs.listUpdated"),
                                timeout: 1000
                            });
                        }
                        this.currentSession = false;
                    });
                }
            }
        });
        this.$root.$on("oneAtATime-catalogs", () => {
            if (this.catalogsReadonly && this.$oneAtATime.state.$currentRoomEmpty) {
                this.loadCatalog(); // refresh catalogs
            }
            this.catalogsReadonly = !this.$oneAtATime.state.$currentRoomEmpty;
            this.$root.$emit("setReadonlyTag", this.catalogsReadonly);
        });
        if (this.refreshCatalog) {
            this.refreshCatalog = false;
        }
        this.catalogLoadedState = false;
        this.$store.commit("catalogs/setSelectedCat", []);
        this.$oneAtATime.destroyCurrentRoom();
        eventBus.$emit("setDefaultState", true);
        this.isModified = false;
        this.$root.$on("backendWebsocketEvents-publishedApp", data => {
            infoToastPublish(data);
            this.$root.$emit("changePublishError");
        });
        this.$root.$on("openChangeHistory", routeName => {
            if (routeName === this.$route.name) {
                this.resetChangeHistory();
                this.getChangeHistory();
            }
        });
        this.$root.$on("showMoreChangeHistory", routeName => {
            if (routeName === this.$route.name) {
                this.changeHistoryCurrentPage++;
                this.getChangeHistory();
            }
        });
    },
    mounted() {
        this.$root.$on("newCatalogAdded", () => {
            this.newCatWasAdded = true;
            this.setNewCatalog(true);
        });
        this.$root.$on("oneAtATime-catalogs-delete", value => {
            if (value === "false") {
                setTimeout(() => {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("oneAtATime.uiReadonlyMessage", { user: this.$oneAtATime.state.$currentEditingUser })
                    });
                }, 500);
            } else if (value === "true") {
                this.deleteCatalog(this.deleteCatalogId).then(() => {
                    this.currentSession = true;
                    this.$oneAtATime.destroyCurrentRoom();
                    this.getCatList();
                    this.getAppSettingsInfo(this.currentApp).then(data => {
                        this.currentApp.publishStatus = data.data.publishStatus;
                        this.$store.commit("apps/setCurrentApp", this.currentApp);
                    });
                })
                    .catch((error) => {
                        this.$oneAtATime.destroyCurrentRoom();
                        this.$toast.showNotify({
                            type: "error",
                            message: error.response.data.status === 404 ? this.$t("catalogs.alreadyDeleted") : error.response.data.error
                        });
                    });
            }
        });

        this.$root.$on("displayCatalog", data => {
            this.displayTable(data);
        });
    },
    deactivated() {
        this.isActive = false;
        this.$root.$off("backendWebsocketEvents-publishedApp");
        this.$root.$off("openChangeHistory");
        this.$root.$off("showMoreChangeHistory");
        this.$root.$off("backendWebsocketEvents-refreshCatList");
        this.$store.commit("main/setSaveBtnVisible", false);
        this.$store.commit("catalogs/setSelectedCatalogData", []);
        this.loadCatalogIndex = -1;
        this.catalogLoadedState = false;
        this.searchVal = "";
    },
    destroyed() {
        this.$root.$emit("disableSaveButton", false);
        this.$root.$off("displayCatalog");
        this.$root.$off("newCatalogAdded");
        this.$root.$off("bc__catalogs__open");
    },
    methods: {
        ...mapActions("catalogs", [
            "getCatList",
            "getTableDetails",
            "getTableFormatFromNewCatalog",
            "expCatListExcel",
            "expCatListJson",
            "getLastCommitId",
            "deleteCatalog",
            "recoverCatalog"
        ]),
        ...mapActions("apps", ["getAppSettingsInfo"]),
        ...mapActions("components", ["getHistoryData", "getNote", "saveDeleteNote"]),
        ...mapMutations("catalogs", ["setItems", "setCatalogsAlreadySaved", "setUnsavedChanges", "setNewCatalog"]),
        publishAppPermissions,
        setNewSelectedCat(index, useItems) {
            const list = useItems ? this.items : this.filteredItems;
            if (list && list[index]) {
                this.isSelectedCat = list[index].id;
                eventBus.$emit("setDefaultState", false);
            } else {
                this.isSelectedCat = null;
                eventBus.$emit("setDefaultState", true);
            }
        },
        breadcrumbsOpen(guid) {
            const clickedCat = this.items.find(({ id }) => id === guid);
            const index = this.items.findIndex(elem => elem.id === clickedCat.id);
            if (clickedCat) {
                this.setNewCatalog(false);
                this.newDisplayTable(clickedCat, index);
            }
            this.$store.commit("main/setInterfaceDirty", false);
            this.$root.$emit("showCheckedSaveBtn", true);
        },
        triggerAction({ action, item }) {
            if (action === "delete") {
                this.deleteThisCatalog(item);
            } else if (action === "download") {
                this.downloadCatalog(item);
            } else if (action === "edit") {
                this.displayTable(item);
            }
        },
        deleteThisCatalog(catalog) {
            this.deleteCatalogId = catalog.id || "";
            this.deleteCatDialog = true;
        },
        deleteCatAction() {
            if (this.deleteCatalogId) {
                this.$oneAtATime.createRoom("catalogs", this.deleteCatalogId, "delete");
            }
        },
        cancelDeleteAction() {
            this.deleteCatDialog = false;
            this.deleteCatalogId = "";
        },
        refreshList() {
            this.loadCatalog("fromImport");
        },
        hideCatalogState() {
            this.loadCatalogIndex = -1;
            this.catalogLoadedState = false;
        },
        newDisplayTable(catalog, index) {
            if (this.$route.params.catalogId !== catalog.id) {
                this.$router.replace({ params: { catalogId: catalog.id } });
            }
            this.setNewSelectedCat(index);
            this.catalogLoadedState = true;
            this.$store.commit("main/setSaveBtnVisible", this.readonlyCatalog);
            this.$root.$emit("showCheckedSaveBtn", !this.interfaceDirty);
            // las asa momentan
            // this.getLastCommitId(catalog.id).then(data => {
            // if (data.data !== this.selectedCat.commitId) {
            this.$store.commit("catalogs/setSelectedCat", catalog);
            const catalogIndex = this.items.findIndex(elem => elem.id === catalog.id);
            this.loadCatalogIndex = catalogIndex;
            // }
            if (this.canWriteCD || this.isOwner) {
                this.$oneAtATime.createRoom("catalogs", catalog.id);
            }
            // });
        },
        okActionState() {
            this.newDisplayTable(this.newSelectedCatalog, this.newSelectedIndex);
        },
        displayTable(catalog) {
            const index = this.filteredItems.findIndex(elem => elem.id === catalog.id);
            if (this.isModified) {
                this.newSelectedCatalog = catalog;
                this.newSelectedIndex = index;
                this.showDialog = true;
            } else {
                this.newDisplayTable(catalog, index);
            }
        },
        modalClosed() {
            if (this.showDlg) {
                this.showDlg = false;
            } else {
                this.showModal = false;
            }
        },
        cancelExport() {
            this.exportCatalog = false;
            this.isSingleCatalog = false;
        },
        downloadCatalog(item) {
            this.exportCatalog = true;
            this.isSingleCatalog = true;
            this.exportCatalogName = item.name;
        },
        exportCatalogAction(singleExport) {
            const catListExpExcel = [];
            let sendListXls = [];
            const currApp = this.currentApp;
            this.$store.commit("catalogs/setCurrApp", currApp);
            if (this.optionExport === "xls") {
                this.items.forEach(element => {
                    if (!element.isNewCat) {
                        catListExpExcel.push(element.name);
                    }
                });
                sendListXls = singleExport ? [this.exportCatalogName] : catListExpExcel;
                this.expCatListExcel(sendListXls).then(() => {
                    this.showNotification();
                })
                    .catch((err) => {
                        const uint8Array = new Uint8Array(err.response.data);
                        const textDecoder = new TextDecoder("utf-8");
                        const decodedText = JSON.parse(textDecoder.decode(uint8Array));
                        this.$toast.showNotify({
                            type: "error",
                            message: decodedText.error,
                            timeout: 500
                        });
                    });
            } else {
                this.items.forEach(element => {
                    if (!element.isNewCat) {
                        catListExpExcel.push(element.name);
                    }
                });
                sendListXls = singleExport ? [this.exportCatalogName] : catListExpExcel;
                this.$store.commit("catalogs/setFromCatList", !singleExport);
                this.expCatListJson(sendListXls).then(() => {
                    this.showNotification();
                });
            }

            this.exportCatalog = false;
            this.isSingleCatalog = false;
        },
        showNotification() {
            this.$toast.showNotify({
                message: this.$t("catalogs.infoExport"),
                type: "success"
            });
        },
        addNew() {
            this.showDlg = true;
            this.searchVal = "";
            const columns = [
                {
                    type: "String",
                    name: "code",
                    delete: false,
                    id: uid(),
                    default: true
                },
                {
                    type: "String",
                    name: "name",
                    delete: false,
                    id: uid(),
                    default: true
                }
            ];
            this.$store.commit("catalogs/setTemporaryColumnsCache", columns);
            this.showEditModal = true;
            this.$store.commit("catalogs/setInEditCatalogColumns", columns);
        },
        importExport() {
            let found = false;
            for (let i = 0; i < this.items.length; i++) {
                if (this.items[i].isNewCat && !this.catalogsAlreadySaved) {
                    this.saveBeforeImportDlg = true;
                    found = true;
                }
            }
            if (!found) {
                this.showModal = true;
                this.$emit("modalClosed", false);
            }
        },
        loadCatalog(fromImport, fromSave) {
            this.skeletonState = true;
            this.getCatList(fromImport).then(() => {
                if (this.items && this.items.length) {
                    if (!Object.entries(this.selectedCat).length) {
                        this.setNewSelectedCat(null, true);
                    } else {
                        const catalogIndex = this.items.findIndex(elem => elem.id === this.selectedCat.id);
                        this.setNewSelectedCat(catalogIndex, true);
                        eventBus.$emit("catListLoaded", catalogIndex);
                    }
                    const { params, query } = this.$route;
                    if (params && params.catalogId) {
                        const catalogToLoad = this.items.find(item => item.id === params.catalogId);
                        if (catalogToLoad) {
                            this.displayTable(catalogToLoad);
                        } else {
                            this.$router.replace({ path: `/applications/${this.currentApp.id}/catalogs`, params: {} });
                        }
                    }
                    if (query && Object.keys(query).length && query.search && this.activatedTriggered) {
                        this.searchTrigger = true;
                        this.searchVal = query.search;
                    }
                    this.activatedTriggered = false;
                }
                if (!fromSave) {
                    this.$root.$emit("showCheckedSaveBtn", true);
                }
                this.skeletonState = false;
            });
        },
        resetChangeHistory() {
            this.changeHistoryData = [];
            this.changeHistoryCurrentPage = 0;
            this.changeHistoryHasMoreItems = true;
        },
        getChangeHistory() {
            if (this.changeHistoryHasMoreItems) {
                const payload = {
                    searchType: "CHANGE_HISTORY",
                    module: "Catalogs",
                    applicationId: this.currentApp.id,
                    page: this.changeHistoryCurrentPage,
                    size: 10
                };
                this.getHistoryData(payload).then(data => {
                    if (data && data.data && data.data.history) {
                        this.changeHistoryData = this.changeHistoryData.concat(data.data.history);
                        this.changeHistoryHasMoreItems = data.data.hasMorePages;
                    }
                    this.changeHistoryModal = true;
                });
            } else {
                this.changeHistoryModal = true;
            }
        },
        modalAction(evt) {
            if (evt === "close") {
                this.changeHistoryModal = false;
            }
        },
        menuItemChangeHistoryClicked(evt) {
            if (evt.menuOptionClicked === "recover") {
                const myDate = new Date();
                const offsetInMinutes = myDate.getTimezoneOffset();
                const payload = {
                    module: "Catalogs",
                    applicationId: this.currentApp.id,
                    elementId: evt.elementId,
                    commitId: evt.items[0].commitId,
                    offsetMinutes: parseInt(offsetInMinutes, 10)
                };
                this.recoverCatalog(payload).then(response => {
                    if (response && response.data) {
                        if (response.data.isSuccessful === true) {
                            this.changeHistoryModal = false;
                            this.currentSession = true;
                            this.$toast.showNotify({
                                type: "success",
                                message: this.$t("versioning.catalogRecovered"),
                                timeout: 2000,
                                hasClose: true
                            });
                            this.loadCatalog();
                            this.getAppSettingsInfo(this.currentApp).then(data => {
                                this.currentApp.publishStatus = data.data.publishStatus;
                                this.$store.commit("apps/setCurrentApp", this.currentApp);
                            });
                        } else {
                            const errorCodes = {
                                ALREADY_RECOVERED: this.$t("versioning.catalogAlreadyRecovered"),
                                MISSING_GUI: this.$t("versioning.catalogNotFound"),
                                NOT_DELETE: this.$t("versioning.interfaceNotDeleteEvent")
                            };
                            if (errorCodes[response.data.errorCode]) {
                                this.$toast.showNotify({
                                    type: "error",
                                    message: errorCodes[response.data.errorCode],
                                    timeout: 3000,
                                    hasClose: true
                                });
                            }
                        }
                    }
                });
            }
        },
        changeSearchUrl(value) {
            const searchText = value.trim();
            const queriesAreDifferent = JSON.stringify({ search: searchText }) !== JSON.stringify(this.$route.query);
            const query = searchText ? { search: searchText } : {};
            if (this.isActive && queriesAreDifferent) {
                this.$router.replace({ path: `/applications/${this.currentApp.id}/catalogs`, query });
            }
        }
    }
};
